import { useState } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import api from "@/lib/api";

export default function ForgotPassword() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const [busy, setBusy] = useState(false);
  const [sent, setSent] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setBusy(true);
    try {
      await api.post("/auth/forgot-password", { email });
    } catch {
      // intentionally silent — response is always generic
    }
    setBusy(false);
    setSent(true);
  };

  return (
    <div className="min-h-screen bg-[#F4F5F7] grid place-items-center px-4">
      <div className="w-full max-w-md">
        <Link to="/" className="flex flex-col items-center gap-3 mb-8" data-testid="forgot-brand">
          <img src="/edujac-mark.png" alt="EDUJAC" className="h-16 w-16 object-contain" />
          <span className="text-center">
            <span className="block font-heading font-extrabold text-[26px] leading-none tracking-wide text-[#00194E]">EDUJAC</span>
            <span className="block text-[11px] font-semibold tracking-[0.08em] text-[#119687] mt-1.5">{t("auth.platformSubtitle")}</span>
          </span>
        </Link>
        <div className="bg-white border border-slate-200 rounded-2xl p-5 sm:p-8 shadow-[0_8px_30px_rgb(0,0,0,0.04)]">
          {sent ? (
            <div className="text-center" data-testid="forgot-success">
              <h1 className="font-heading text-2xl font-bold">{t("auth.checkInbox")}</h1>
              <p className="text-sm text-slate-500 mt-3 leading-relaxed">
                {t("auth.resetInstructionsSent")}
              </p>
              <Link to="/login" data-testid="forgot-back-login" className="inline-block mt-6 text-sm font-bold text-brand-coralDark hover:underline">
                {t("auth.backToLogin")}
              </Link>
            </div>
          ) : (
            <form onSubmit={submit} data-testid="forgot-form">
              <h1 className="font-heading text-2xl font-bold">{t("auth.forgotPassword")}</h1>
              <p className="text-sm text-slate-500 mt-1">{t("auth.forgotSubtitle")}</p>
              <div className="mt-6 space-y-4">
                <div>
                  <Label htmlFor="forgot-email">{t("common.email")}</Label>
                  <Input id="forgot-email" data-testid="forgot-email" type="email" required className="mt-1.5" value={email} onChange={(e) => setEmail(e.target.value)} placeholder="you@school.in" />
                </div>
                <Button type="submit" data-testid="forgot-submit" disabled={busy} className="w-full rounded-full bg-brand-coral hover:bg-brand-coralDark text-white font-bold py-5 transition-transform duration-300 active:scale-95">
                  {busy ? t("auth.sending") : t("auth.sendResetLink")}
                </Button>
                <p className="text-center text-xs">
                  <Link to="/login" className="font-semibold text-slate-500 hover:text-brand-coralDark" data-testid="forgot-back-login-link">{t("auth.backToLogin")}</Link>
                </p>
              </div>
            </form>
          )}
        </div>
      </div>
    </div>
  );
}
